'use strict';

import axios from 'axios';
import { gtmCustomEvent } from '@jspartials/gtm-utils';

import {
  classes,
  addClassToElement,
  removeClassToElement
} from '@jspartials/class-list-utils';

// Selectors
const selector = {
  button: {
    addToWishList: '.js-add-to-wish-list',
    removeFromWishList: '.js-remove-from-wish-list'
  },
  icon: {
    filled: '.js-add-to-wish-list__icon--filled',
    unfilled: '.js-add-to-wish-list__icon--unfilled'
  },
  wrapper: {
    item: '.js-wishlist-item',
    empty: '.js-wishlist__empty-wrapper'
  }
};

const Actions = {
  added: 'added',
  removed: 'removed'
};

function showItemInWishlistIcon(wishListButton) {
  wishListButton.dataset.wishlist = true;
  const filledIcon = wishListButton.querySelector(selector.icon.filled);
  const unfilledIcon = wishListButton.querySelector(selector.icon.unfilled);
  addClassToElement(filledIcon, classes.has.success);
  addClassToElement(unfilledIcon, classes.hidden);
  removeClassToElement(filledIcon, classes.hidden);
}

function showItemNotInWishlistIcon(wishListButton) {
  wishListButton.dataset.wishlist = false;
  const filledIcon = wishListButton.querySelector(selector.icon.filled);
  const unfilledIcon = wishListButton.querySelector(selector.icon.unfilled);
  addClassToElement(filledIcon, classes.hidden);
  removeClassToElement(filledIcon, classes.has.success);
  removeClassToElement(unfilledIcon, classes.hidden);
}

function synchronizeWishlistButtons(action) {
  if (!action) return;

  const wishListButtons = document.querySelectorAll(
    selector.button.addToWishList
  );
  wishListButtons.forEach((wishListButton) => {
    if (action === Actions.added) {
      showItemInWishlistIcon(wishListButton);
    } else if (action === Actions.removed) {
      showItemNotInWishlistIcon(wishListButton);
    }
  });
}

function addProductToWishlistListener() {
  const wishListButtons = document.querySelectorAll(
    selector.button.addToWishList
  );
  if (wishListButtons) {
    wishListButtons.forEach((wishListButton) => {
      wishListButton.addEventListener('click', function (e) {
        e.preventDefault();

        var pid = wishListButton.dataset.pid;

        // Check if product is already in wishlist
        var isInWishList =
          wishListButton.dataset.wishlist.toLowerCase() === 'true';

        if (!pid) {
          return;
        }

        const formData = new FormData();
        formData.append('pid', pid);

        if (!isInWishList) {
          // Add product to wishlist
          axios
            .post(globalVariables.endpoint.addProductToWishList, formData)
            .then(function (response) {
              if (response.status === 200) {
                synchronizeWishlistButtons(Actions.added);
                document.dispatchEvent(
                  new CustomEvent(gtmCustomEvent.afterAddToWishlit, {
                    detail: {
                      productId: pid
                    }
                  })
                );
              }
            })
            .catch((error) => {
              console.error(error);
            });
        } else {
          // Remove product from wishlist
          axios
            .get(globalVariables.endpoint.removeProductFromWishList, {
              params: {
                pid: pid
              }
            })
            .then(function (response) {
              if (response.status === 200) {
                synchronizeWishlistButtons(Actions.removed);
                document.dispatchEvent(
                  new CustomEvent(gtmCustomEvent.afterRemoveFromWishlist, {
                    detail: {
                      productId: pid
                    }
                  })
                );
              }
            })
            .catch((error) => {
              console.error(error);
            });
        }
      });
    });
  }
}
function removeProductFromWishListListener() {
  // Get all remove buttons from products in wishlist
  const wishListRemoveButtons = document.querySelectorAll(
    selector.button.removeFromWishList
  );

  if (wishListRemoveButtons) {
    wishListRemoveButtons.forEach((wishListButton) => {
      wishListButton.addEventListener('click', function (e) {
        e.preventDefault();
        var pid = wishListButton.dataset.pid;
        if (!pid) {
          return;
        }

        axios
          .get(globalVariables.endpoint.removeProductFromWishList, {
            params: {
              pid: pid
            }
          })
          .then(function (response) {
            if (response.status === 200) {
              const itemContainer = document.querySelector(
                '.js-wishlist-item[data-pid="' + pid + '"]'
              );

              // Remove item from wishlist
              itemContainer.remove();

              // Send event to GTM
              document.dispatchEvent(
                new CustomEvent(gtmCustomEvent.afterRemoveFromWishlist, {
                  detail: {
                    productId: pid
                  }
                })
              );

              checkForEmptyWishlist();
            }
          })
          .catch((error) => {
            console.error(error);
          });
      });
    });
  }
}

function checkForEmptyWishlist() {
  // Get all items from wishlist
  const wishListItems = document.querySelectorAll(selector.wrapper.item);

  const emptyWishlistWrapper = document.querySelector(selector.wrapper.empty);

  if (wishListItems.length === 0) {
    removeClassToElement(emptyWishlistWrapper, classes.hidden);
  }
}

function initWishlistButtonsListeners() {
  addProductToWishlistListener();
  removeProductFromWishListListener();
}

export { initWishlistButtonsListeners };
